import React from 'react';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import Options from 'Components/Options';
import { Divider, Grid, MenuItem, ListItemText, ListItem, ListItemAvatar, Avatar } from '@mui/material';
import useLogOut from 'Hooks/useLogOut';
import useTranslation from 'Hooks/useTranslation';

export default function PanelHeader({ name = '', email = '', image = 'src/fake' }) {
  const { t2 } = useTranslation('Dashboard');
  const { logOutApi } = useLogOut();

  return (
    <div>
      <Grid container alignItems="center">
        <Grid item xs={9}>
          <ListItem>
            <ListItemText primary={name} secondary={email} style={{ textAlign: 'right' }} />
          </ListItem>
        </Grid>
        <Grid item xs={3}>
          <Options
            Icon={
              <Grid container display="flex" alignItems="center" spacing={0}>
                <Grid item xs={7}>
                  <ListItemAvatar>
                    <Avatar alt={name} src={image} />
                  </ListItemAvatar>
                </Grid>
                <Grid item xs={3}>
                  <KeyboardArrowDownIcon color="MexlogGreen" />
                </Grid>
              </Grid>
            }
            disabledEffect
          >
            <MenuItem onClick={logOutApi}>{t2('Logout')}</MenuItem>
          </Options>
        </Grid>
      </Grid>
      <Divider />
    </div>
  );
}
